import { Injectable } from '@angular/core';
import {
  FORMPI_MOVE_TO_TOUR,
  PostProcessor,
  PostProcessorType,
} from '../post-processor';
import { LoggingService } from '../../logging/logic/logging.service';
import { PostProcessorXML } from 'src/app/_model/dyn-form/dyn-form-xml';
import { DynForm } from 'src/app/_model/dyn-form';
import { IMSObject } from 'src/app/_model/ims-object';
import { RemoteActionUpdateObject } from 'src/app/_model/remote-action/remote-action-builder/remote-action-builder';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { SyncJobsAction } from '../../action-interpreter/action-handlers/sync-jobs-action-handler.service';

@Injectable({
  providedIn: 'root',
})
export class MoveToTourFormFieldPostProcessor implements PostProcessor {
  // Public Member
  constructor(private logger: LoggingService) {}
  public readonly name: PostProcessorType = FORMPI_MOVE_TO_TOUR;

  // Lifecycle
  async postProcess(
    form: DynForm,
    formData: any,
    imsObject: IMSObject,
    postProcessorXml?: PostProcessorXML,
    remoteAction?: RemoteAction,
  ): Promise<RemoteActionUpdateObject[]> {
    this.logger.log(
      this.constructor.name,
      'add sync jobs to afterSendActions',
      formData,
    );

    remoteAction.afterSendActions.push(SyncJobsAction);

    return undefined;
  }
}
